import { createFileRoute, Outlet } from '@tanstack/react-router'

import {
  CreditsNav,
  HiddenOnTrial,
  useFetchCreditBank,
} from '@/modules/account'
import { useIsScreenerEntitled } from '@/modules/tools/bankruptcy'

export const Route = createFileRoute('/_authenticated/credits')({
  component: CreditsRoute,
})

function CreditsRoute() {
  return (
    <HiddenOnTrial>
      <CreditsLayout />
    </HiddenOnTrial>
  )
}

function CreditsLayout() {
  useFetchCreditBank()
  const isScreenerEntitled = useIsScreenerEntitled()

  return (
    <div className="mx-auto max-w-6xl space-y-8 p-6">
      <div className="space-y-1">
        <h1 className="text-3xl font-bold tracking-tight">Credits</h1>
        <p className="text-muted-foreground text-lg">
          {isScreenerEntitled
            ? 'One bank, two balances: top up page and screenings credits separately.'
            : 'Top up your account with a credit refill package.'}
        </p>
      </div>

      <CreditsNav />

      <Outlet />
    </div>
  )
}
